<template>
  <div class="container-fluid">
    <div class="page-titles">
      <h2 class="text-black font-w600">Perfil Personal</h2>
    </div>
    <div class="row">
      <div class="col-12">
        <!-- Profile Tab Content -->
        <form @submit.prevent="update" method="POST">
          <div class="card">
            <div class="card-body">
              <!-- About Me -->
              <h4 class="card-title">Datos de usuario</h4>
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Nombre</label>
                    <input
                      v-model="userData.user.names"
                      type="text"
                      class="form-control"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Apellido</label>
                    <input
                      v-model="userData.user.surnames"
                      type="text"
                      class="form-control"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Usuario</label>
                    <input
                      v-model="userData.user.username"
                      type="text"
                      class="form-control"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Email</label>
                    <input
                      v-model="userData.user.email"
                      type="email"
                      class="form-control"
                      readonly
                    />
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Número de identificación</label>
                    <input
                      v-model="userData.document"
                      type="text"
                      class="form-control"
                      readonly
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Teléfono</label>
                    <input
                      v-model="userData.phone"
                      type="text"
                      class="form-control"
                    />
                    <small v-if="errors.phone" class="text-danger">{{
                      errors.phone[0]
                    }}</small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>
                      Fecha de nacimiento
                      <span class="text-danger">*</span>
                    </label>
                    <v-menu
                        ref="menuDatePicker"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :value="personBirthdayDateFormatted"
                            v-bind="attrs"
                            v-on="on"
                            prepend-icon="mdi-calendar"
                            readonly
                            clearable
                            @click:clear="userData.birthday_date=null"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          ref="birthdayPicker"
                          v-model="userData.birthday_date"
                          :active-picker.sync="activePicker"
                          :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
                          min="1900-01-01"
                          locale="es-ES"
                          :landscape="!$vuetify.breakpoint.mobile"
                          @change="saveMenuPickerDate"
                      ></v-date-picker>
                    </v-menu>
                    <small v-if="errors.birthday_date" class="text-danger">{{
                        errors.birthday_date[0]
                      }}</small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label">Ocupación</label>
                    <v-autocomplete
                        class="form-control"
                        :items="occupations"
                        flat
                        hide-details
                        hide-no-data
                        solo-inverted
                        item-text="display_name"
                        item-value="id"
                        v-model="userData.occupation_id"
                    ></v-autocomplete>
                    <small v-if="errors.occupation_id" class="text-danger">{{
                        errors.occupation_id[0]
                      }}</small>
                  </div>
                </div>
              </div>
              <!-- /About Me -->

              <!-- Contact Details -->
              <h4 class="card-title mt-3">Datos de contacto</h4>
              <div class="form-row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Dirección</label>
                    <input
                      v-model="userData.address.address"
                      type="text"
                      class="form-control"
                    />
                    <small v-if="errors.address" class="text-danger">{{
                      errors.address[0]
                    }}</small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label">Ciudad</label>
                    <input
                      v-model="userData.address.city"
                      type="text"
                      class="form-control"
                    />
                    <small v-if="errors.city" class="text-danger">{{
                      errors.city[0]
                    }}</small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label">Estado / Provincia</label>
                    <input
                      v-model="userData.address.state"
                      type="text"
                      class="form-control"
                    />
                    <small v-if="errors.state" class="text-danger">{{
                      errors.state[0]
                    }}</small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label">País</label>
                    <v-autocomplete
                      class="form-control"
                      :items="countries"
                      flat
                      hide-details
                      hide-no-data
                      solo-inverted
                      item-text="name"
                      item-value="id"
                      v-model="userData.address.country_id"
                    ></v-autocomplete>
                    <small v-if="errors.country_id" class="text-danger">{{
                      errors.country_id[0]
                    }}</small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label">Código Postal</label>
                    <input
                      v-model="userData.address.zip"
                      type="text"
                      class="form-control"
                    />
                    <small v-if="errors.zip" class="text-danger">{{
                      errors.zip[0]
                    }}</small>
                  </div>
                </div>
              </div>
              <!-- /Contact Details -->

              <div class="submit-section submit-btn-bottom text-right mt-4">
                <button type="submit" class="btn btn-primary btn-lg">
                  Actualizar
                </button>
              </div>
            </div>
          </div>
        </form>
        <!-- /Profile Tab Content -->
      </div>
    </div>
  </div>
</template>

<style src="@/assets/scss/content.scss" lang="scss" scoped></style>

<script>
import { EventBus } from "@/main";
import global from "@/helpers/global";
import date from  '../../helpers/date';

export default {
  data() {
    return {
      userData: {
        document: "",
        phone: "",
        user: {
          names: "",
          surnames: "",
          username: "",
          email: "",
          password: "",
          password_confirmation: "",
        },
        address: {
          address: "",
          city: "",
          state: "",
          zip: "",
          country_id: "",
        },
        document_image: "",
        avatar: "",
        accept_terms: false,
        occupation_id: null
      },
      menu: false,
      activePicker: 'YEAR',
      countries: [],
      occupations: [],
      errors: [],
    };
  },
  mixins: [global, date],
  beforeMount() {
    if (!this.curUser.roles.find((o) => o.name === "person")) {
      this.$router.push("/monedero");
      return;
    }

    this.getCountries();
    this.getOccupations();

    axios
      .get(
        process.env.VUE_APP_API_URL +
          "/api/v1/profiles/person/get/" +
          this.curUser.person.id
      )
      .then((response) => {
        //console.log(response.data.person);
        this.userData = response.data.person;
        //console.log(response.data.message);
      })
      .catch((error) => {
        this.errors = [];

        if (error.response != undefined) {
          this.errors = error.response.data.errors ?? [];

          EventBus.$emit("showErrors", {
            msg: error.response.data.error,
          });

          console.log(error.response.data.error);
        }
      });
  },
  mounted() {},
  methods: {
    update: function() {
      $("#preloader").fadeIn();

      axios
        .put(
          process.env.VUE_APP_API_URL +
            "/api/v1/profiles/person/update/" +
            this.curUser.person.id,
          this.userData
        )
        .then((response) => {
          //console.log(response.data.person);
          this.userData = response.data.person;

          $("#preloader").fadeOut();

          EventBus.$emit("showInfo", {
            msg: response.data.message,
          });

          //console.log(response.data.message);
        })
        .catch((error) => {
          this.errors = [];

          if (error.response != undefined) {
            this.errors = error.response.data.errors ?? [];

            EventBus.$emit("showErrors", {
              msg: error.response.data.error,
            });

            console.log(error.response.data.error);
          }

          $("#preloader").fadeOut();
        });
    },
  },

  watch: {
    menu(val) {
      val && this.$nextTick(() => (this.$refs.birthdayPicker.activePicker = 'YEAR'));
    },
  },
};
</script>
